<template>
  <div class="common-table">
    <a-spin :spinning="loading" style="background: #fff;">
      <a-skeleton v-show="loading" :paragraph="{rows: 10}" />
    </a-spin>
    <div v-show="!loading">
      <a-card :bordered="false">
        <customer-summary v-if="basicData" :initData="basicData" :countryList="countryList"></customer-summary>
      </a-card>
      <div v-if="basicData">
        <div>
          <div class="tabs-define-box">
            <a-tabs type="card" :activeKey="currentActiveTabKey" @change="handleTabChange" style="padding-bottom: 0;padding-top: 0;">
              <a-tab-pane key="1" tab="Profile" :forceRender="true" class="profile-tab">
                <div class="custom-section-box">
                  <div class="ant-advanced-search-form item">
                    <div style="display: table;">
                      <cdb-basic
                        :initData="basicData"
                        :initEmergencyContact="previewData.emergencyContact"
                        :titleList="titleList"
                        :backgroundList="backgroundList"
                        :ethnicitiesList="ethnicitiesList"
                        :languageList="languageList"
                        :realationShipList="realationShipList"
                      ></cdb-basic>
                    </div>
                  </div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="2" tab="Travel Documents" :forceRender="true">
                <div class="custom-section-box">
                  <div class="ant-advanced-search-form item">
                    <cdb-passport-list
                      :passportList="previewData.passportList"
                      :customerId="previewData.id"
                      :customerBirthday="previewData.birthday"
                      :PassportTravelDocList="PassportTravelDocList"
                      :isShowEdit="true"
                      :isMainShow="true"
                    />
                    <cdb-customer-other-documents-list
                      :otherList="previewData.otherPassportList"
                      :customerId="previewData.id"
                      :customerBirthday="previewData.birthday"
                      :PassportTravelDocList="PassportTravelDocList"
                      :isShowEdit="true"
                      :isMainShow="true"
                    />
                  </div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="3" tab="Tour" :forceRender="true">
                <div class="custom-section-box">
                  <div class="ant-advanced-search-form item">
                    <div style="display: table;">
                      <div style="display: flex;margin-bottom: 14px;">
                        <div style="flex: 1;">
                          <a-radio-group v-model="currentWebSiteType" @change="e => handleWebSiteTypeChange(e, 'tour')">
                            <a-radio-button value="Signet">Signet</a-radio-button>
                            <a-radio-button value="Supera">Supera</a-radio-button>
                          </a-radio-group>
                        </div>
                      </div>
                      <table class="info-table">
                        <tr>
                          <td class="info-cell">
                            <div class="cell-content">
                              <div class="label">Room Prefer:</div>
                              <div class="value" style="white-space: nowrap;" v-if="previewData.roomPreferred">{{ previewData.roomPreferred == '1' ? 'TWN' : 'DBL' }}</div>
                            </div>
                          </td>
                          <td class="info-cell">
                            <div class="cell-content">
                              <div class="label">Meal Restriction:</div>
                              <div class="value" :title="previewData.mealsRequestName.map(formatName).join('; ')">{{ previewData.mealsRequestName.map(formatName).join('; ') }}</div>
                            </div>
                          </td>
                          <td class="info-cell">
                            <div class="cell-content">
                              <div class="label">Motion sickness:</div>
                              <div class="value" :title="previewData.specialRequestName.map(formatName).join('; ')">{{ previewData.specialRequestName.map(formatName).join('; ') }}</div>
                            </div>
                          </td>
                          <!-- <td class="info-cell">
                            <div class="cell-content">
                              <div class="label">Internal note:</div>
                              <div class="value" :title="editData.specialNote">{{ editData.specialNote }}</div>
                            </div>
                          </td> -->
                        </tr>
                      </table>
                      <customer-airlines
                        :ffpList="previewData.ffpList"
                        :airlineList="airlineList"
                        :isEditTour="true"
                        :globalCode="previewData.globalCode"
                        :isShowEdit="true"
                        :isMainShow="true"
                      ></customer-airlines>
                    </div>
                    <div style="padding-top: 14px;display: table;">
                      <div class="title">Tour Records</div>
                      <a-table
                        rowKey="bkrId"
                        :columns="mainColumns"
                        :data-source="currentWebSiteType == 'Signet' 
                        ? (previewData.cusSignetRecord && previewData.cusSignetRecord.datas ? previewData.cusSignetRecord.datas : []) 
                        : (previewData.cusSuperaRecord && previewData.cusSuperaRecord.datas ? previewData.cusSuperaRecord.datas : [])"
                      >
                        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
                        <span slot="tourCode" slot-scope="text, record"><span>{{ record.tourCode }}</span></span>
                        <span slot="bkrId" slot-scope="text, record">
                          <div style="display: flex;">
                            <div v-if="record.recordType !== 3" style="display: flex;">
                              <a :href="getOBSCodeUrl(record.bkrId)" target="_blank">{{ record.bkrId }}</a>
                              <template v-if="record.recordType == 2">
                                <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '1000px' }">
                                    <template slot="title">
                                      <div>Please confirm whether it is an order from this customer</div>
                                    </template>
                                    <div style="margin-left: 10px;color: #C00000;"><a-icon type="question-circle" /></div>
                                  </a-tooltip>
                              </template>
                            </div>
                            <span v-else>{{ record.bkrId }}</span>
                          </div>
                        </span>
                        <span slot="bkrStatus" slot-scope="text, record">
                          <span v-if="record.bkrStatus == '0'">New Booking</span>
                          <span v-if="record.bkrStatus == '1' && record.depositEnoughFlag == '1'">Deposited</span>
                          <span v-if="record.bkrStatus == '1' && record.depositEnoughFlag == '2'">Paid In Full</span>
                          <span v-if="record.bkrStatus == '2'">Invoiced</span>
                          <span v-if="record.bkrStatus == '5'">Completed</span>
                          <span v-if="record.bkrStatus == '-1'">Cancelled</span>
                        </span>
                        <span slot="startDate" slot-scope="text">
                          {{ dateFormatB(text) }}
                        </span>
                      </a-table>
                    </div>
                  </div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="4" tab="Coupon" :forceRender="true">
                <div class="custom-section-box">
                  <div class="ant-advanced-search-form item">
                    <div style="margin-bottom: 14px;">
                      <a-radio-group v-model="currentCouponWebSiteType" @change="e => handleWebSiteTypeChange(e, 'coupon')">
                        <a-radio-button value="Signet">Signet</a-radio-button>
                        <a-radio-button value="Supera">Supera</a-radio-button>
                      </a-radio-group>
                    </div>
                    <a-table
                      rowKey="id"
                      :columns="columns"
                      :data-source="currentCouponWebSiteType == 'Signet' 
                      ? (previewData.cusSignetCoupon && previewData.cusSignetCoupon.datas ? previewData.cusSignetCoupon.datas : []) 
                      : (previewData.cusSuperaCoupon && previewData.cusSuperaCoupon.datas ? previewData.cusSuperaCoupon.datas : [])"
                    >
                      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
                      <span slot="couponCode" slot-scope="text, record">
                        {{ record.couponCode }}
                      </span>
                      <span slot="description" slot-scope="text, record">
                        <div :title="record.description" style="max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ record.description }}</div>
                      </span>
                      <span slot="amount" slot-scope="text, record">
                        <div v-if="record.bkrfr" style="white-space: nowrap;">
                          <span v-if="record.bkrfr == 'sigusa' || record.bkrfr == 'supusa'">USD {{ record.amount }}</span>
                          <span v-if="record.bkrfr == 'sigcan' || record.bkrfr == 'supcan'">CAD {{ record.cAmount }}</span>
                        </div>
                        <div v-else style="white-space: nowrap;">
                          <div v-if="record.amount">USD {{ record.amount }}</div>
                          <div v-if="record.cAmount">CAD {{ record.cAmount }}</div>
                        </div>
                      </span>
                      <!-- <span slot="startDate" slot-scope="text">{{ dateFormatB(text) }}</span> -->
                      <!-- 优惠券状态 0 未使用 1 已使用 -->
                      <span slot="couponStatus" slot-scope="text, record">
                        <a-tag 
                          v-if="text === '0'" 
                          :color="record.expirationDate && new Date(record.expirationDate) < new Date() ? '#DC3545' : '#198754'"
                        >
                          {{ text === '0' && record.expirationDate && new Date(record.expirationDate) < new Date() ? 'Expired' : 'Available' }}
                        </a-tag>
                        <a-tag v-else :color="record.transferToCustomerCode && record.transferToCustomerCode.length > 0 ? '#faad14' : '#6C757D'">
                          {{ (record.transferToCustomerCode && record.transferToCustomerCode.length > 0) ? 'Transferred' : 'Used' }}
                        </a-tag>
                      </span>
                    </a-table>
                  </div>
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/common-table-list.css'
import '@/assets/css/footer.css'
// import moment from 'moment'
import FooterToolBar from '@/components/FooterToolbar'
import CdbBasic from './CdbCustomerBasic'
import CustomerSummary from './CdbCustomerSummary'
import CdbCustomerOtherDocumentsList from './CdbCustomerOtherDocumentsList'
import CdbPassportList from './CdbCustomerPassportList'
import CustomerAirlines from './CdbCustomerAirlinesFrequentFlyer'
import TourRecords from './tourRecord/CdbCustomerTourRecordList'
import CustomerApi from '@/api/api-cdb-custome-v2'
import CountryApi from '@/api/basicdata/api-country'
import { Title } from '@/utils/helper/standard-code-utils'
import { Language, Background, Ethnicities, TravelDoc, Meals, Special} from '@/utils/helper/dict-cdb-utils'

export default {
  name: 'CdbCustomerPreview',
  components: {
    FooterToolBar,
    CdbBasic,
    CustomerSummary,
    CdbPassportList,
    CdbCustomerOtherDocumentsList,
    CustomerAirlines,
    TourRecords
  },
  props: {
    previewData: {
      type: [String, Object],
      default: null
    },
  },
  data () {
    return {
      loading: false,
      // 基础数据
      basicData: null,
      // 紧急联系人
      emergencyContact: null,
      countryList: [],
      titleList: Title.dict,
      backgroundList: [],
      ethnicitiesList: [],
      languageList: [],
      realationShipList: [],
      PassportTravelDocList: [],
      airlineList: [],
      currentActiveTabKey: '1',
      currentWebSiteType: 'Signet',
      currentCouponWebSiteType: 'Signet',
      mainColumns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          align:'center',
          width: '35px',
        },
        {
          title: 'Booking No.',
          dataIndex: 'bkrId',
          scopedSlots: { customRender: 'bkrId' }
        },
        {
          title: 'Tour Code',
          dataIndex: 'tourCode',
          scopedSlots: { customRender: 'tourCode' }
        },
        {
          title: 'Date',
          dataIndex: 'createDate',
          customRender: (value) => this.dateFormatB(value)
        },
        {
          title: 'Status',
          dataIndex: 'bkrStatus',
          width: '100px',
          scopedSlots: { customRender: 'bkrStatus' }
        },
        {
          title: 'Price',
          dataIndex: 'roomPrice',
          customRender: (value) => {
            return this.moneyFormatThousandNoZero(this.moneyFormatThousand(value))
          }
        },
      ],
      columns: [
        {
          title: '#',
          align:'center',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: 'Code',
          dataIndex: 'couponCode',
          scopedSlots: { customRender: 'couponCode' }
        },
        {
          title: 'Description',
          dataIndex: 'description',
          scopedSlots: { customRender: 'description' }
        },
        {
          title: 'Amount',
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' }
        },
        {
          title: 'Status',
          dataIndex: 'couponStatus',
          // customRender: (value) => value == '0' ? 'Not Use' : 'Used'
          scopedSlots: { customRender: 'couponStatus' }
        },
      ],
      signetCouponList: [],
      mealsList: null,
      specialList: null,
    }
  },
  mounted () {
    this.initData()
    this.queryAirList()
  },
  methods: {
    async initData () {
      this.loading = true
      try {
        // 加载国家数据
        const resCountry = await CountryApi.list()
        const countryList = resCountry.data
        this.countryList = countryList
        this.languageList = await Language.getDict()
        this.backgroundList = await Background.getDict()
        this.ethnicitiesList = await Ethnicities.getDict()
        this.PassportTravelDocList = await TravelDoc.getDict()
        this.mealsList = await Meals.getDict()
        this.specialList = await Special.getDict()

        const res = await CustomerApi.getCusRelationshipList()
        this.realationShipList = res.data || []

        // 餐食需求
        if (this.previewData.mealsRequest?.trim()) {
          this.previewData.mealsRequestName = this.previewData.mealsRequest.split(',')
            .map(code => {
              const found = this.mealsList.find(item => item.code === code.trim())
              return found || { enName: code, twName: code }
            })
            .filter(item => item.enName && item.twName)
        } else {
          this.previewData.mealsRequestName = []
        }

        // 特别需求 (同理)
        if (this.previewData.specialRequest?.trim()) {
          this.previewData.specialRequestName = this.previewData.specialRequest.split(',')
            .map(code => {
              const found = this.specialList.find(item => item.code === code.trim())
              return found || { enName: code, twName: code }
            })
            .filter(item => item.enName && item.twName)
        } else {
          this.previewData.specialRequestName = []
        }
        
        this.basicData = {
          firstName: this.previewData.firstName, 
          lastName: this.previewData.lastName, 
          preferToBeCalled: this.previewData.preferToBeCalled, 
          fullName: this.previewData.fullName, 
          middleName: this.previewData.middleName, 
          gender: this.previewData.gender, 
          birthday: this.previewData.birthday,
          title: this.previewData.title,
          languages: this.previewData.languages,
          otherLanguages: this.previewData.otherLanguages,
          ethnicitiesId: this.previewData.ethnicitiesId,
          nationalBackground: this.previewData.nationalBackground,
          mealsRequest: this.previewData.mealsRequest,
          specialRequest: this.previewData.specialRequest,
          contactList: this.previewData.contactList,
          addressList: this.previewData.addressList,
          emergencyContact: this.previewData.emergencyContact,
          globalCode: this.previewData.globalCode,
          rsList: this.previewData.rsList
        }
      } catch (e) {
        console.log('e', e)
      } finally {
        this.loading = false
      }
    },
    async queryAirList () { 
      try {
        const res = await CustomerApi.getAirServiceList()
        this.airlineList = res.data || []
      } catch (error) {
        console.error('Error loading airline list:', error)
      }
    },
    handleTabChange (key) {
      this.currentActiveTabKey = key
    },
    handleWebSiteTypeChange (e, type) {
      if (type == 'tour') {
        this.currentWebSiteType = e.target.value
      } else if (type == 'coupon') {
        this.currentCouponWebSiteType = e.target.value
      }
    },
    formatName (item) {
      return item?.enName ? `${item.enName}/${item.twName}` : ''
    },
    getOBSCodeUrl (bkrId) {
      const env = process.env.NODE_ENV
      if (env === 'production' || env === 'test') {
        return process.env.VUE_APP_OBS_PUBLIC_URL + '/obs_queryBooking.do?bkrId=' + bkrId
      } else {
        // 开发环境
        return `https://nike.supernettours.com/obs_queryBooking.do?bkrId=${ bkrId }`
      }
    },
  },
  watch: {
  }
}
</script>
<style lang="less" scoped>
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
  max-height: 1000px;
  overflow: hidden;
}
.slide-enter, .slide-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
::v-deep .ant-advanced-search-form {
  padding-top: 16px;
}
.profile-tab {
  .edit-icon {
    font-size: 16px;
    position: absolute;
    right: 0;
    top: 4px;
    cursor: pointer;
    z-index: 1;
  }
}
::v-deep .ant-tabs {
  overflow: visible;
}
::v-deep .ant-tabs-bar {
  margin: 0;
}
::v-deep .ant-advanced-search-form .ant-form-item {
  margin-bottom: 0;
}
::v-deep .ant-col .ant-form-item-label {
  line-height: 30px;
}
.info-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 12px;
  .info-cell {
    padding-right: 20px;
    vertical-align: top;
    .cell-content {
      display: flex;
      flex-direction: row; 
      gap: 8px;
      .label {
        font-weight: bold;
        color: #333;
        white-space: nowrap; 
      }
      .value {
        max-width: 200px;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
      }
    }
  }
}
</style>